/**
 * Shared columns for the "referred customers" table (employee referral detail + account summary).
 */
import type { TFunction } from 'i18next'
import type { DataTableColumn } from '@/components/ui/data-table-customized'

export interface ReferredCustomerRow {
    customer_id: number
    customer_name?: string
    customer_email?: string
    company_name?: string
}

export const getReferredCustomersColumns = (
    t: TFunction
): DataTableColumn<ReferredCustomerRow>[] => [
    {
        key: 'customer_name',
        title: t('customer'),
        width: 240,
        render: (_, row) => row.customer_name || '-',
    },
    {
        key: 'customer_email',
        title: t('email'),
        width: 240,
        render: (value) => (value as string) || '-',
    },
    {
        key: 'company_name',
        title: t('company', 'Company'),
        width: 200,
        render: (value) => (value as string) || '-',
    },
]
